import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/Screens/loginScreen/ModernLoginMain.js");
